import { render, staticRenderFns } from "./EdenImageUpload.vue?vue&type=template&id=1815904a&scoped=true"
import script from "./EdenImageUpload.vue?vue&type=script&lang=js"
export * from "./EdenImageUpload.vue?vue&type=script&lang=js"
import style0 from "./EdenImageUpload.vue?vue&type=style&index=0&id=1815904a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1815904a",
  null
  
)

export default component.exports